import React from 'react';
import { Trophy, Gamepad2, TrendingUp, Swords } from 'lucide-react';
import { StatsDisplay } from './StatsDisplay';
import type { H2HChallengeViewProps } from './types';
import styles from './H2HChallengeView.module.css';

export function H2HChallengeView({ stats, challenge, signatureColor }: H2HChallengeViewProps) {
  // Handle null stats gracefully
  const hasStats = stats !== null && stats !== undefined;
  
  // Format win percentage
  const formatWinPercentage = (percentage?: number) => {
    if (percentage === undefined || percentage === null) return '0%';
    return `${percentage.toFixed(0)}%`;
  };
  
  // Format win-loss record
  const formatRecord = (wins?: number, losses?: number) => {
    const w = wins || 0;
    const l = losses || 0;
    return `${w}-${l}`;
  };
  
  // Format active games
  const formatActiveGames = (games?: number) => {
    return games || 0;
  };
  
  return (
    <div className={styles.container}>
      {/* H2H Stats Grid */}
      {!hasStats ? (
        <div className={styles.noStatsMessage}>
          <p>No H2H games played yet</p>
          <p className={styles.subtext}>Start playing to see your stats!</p>
        </div>
      ) : (
        <div className={styles.statsGrid}>
          <StatsDisplay
            value={formatActiveGames(stats.activeGames)}
            label="Active Games"
            signatureColor={signatureColor}
          />
          <StatsDisplay
            value={formatWinPercentage(stats.winPercentage)}
            label="Win Percentage"
            signatureColor={signatureColor}
          />
          <StatsDisplay
            value={formatRecord(stats.wins, stats.losses)}
            label="Win-Loss"
            signatureColor={signatureColor}
          />
        </div>
      )}
      
      {/* Theme Info Section */}
      <div className={styles.themeInfo} style={{ backgroundColor: 'var(--signature-color-soft)' }}>
        <h3 className={styles.themeLabel}>
          This Week's Theme
        </h3>
        <div className={styles.themeName} style={{ color: signatureColor, WebkitTextFillColor: signatureColor }}>
          {challenge.puzzleName}
        </div>
        {hasStats && stats.averageGamesPlayed !== undefined && (
          <div className={styles.themeDetails}>
            Average Games Played: {stats.averageGamesPlayed.toFixed(1)}
          </div>
        )}
      </div>
    </div>
  );
}